/**
 * ATTENTION! This file is auto-generated for the 'reporting' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';

type listReportsType = typeof import('../server/functions/listReports').listReports;
export const listReports: RpcFunctionClient<listReportsType> = makeFunctionProxy<listReportsType>('reporting::listReports');

type generateReportType = typeof import('../server/functions/generateReport').generateReport;
export const generateReport: RpcFunctionClient<generateReportType> = makeFunctionProxy<generateReportType>('reporting::generateReport');
